import { render, staticRenderFns } from "./GameStatus.vue?vue&type=template&id=7fceb21a"
import script from "./GameStatus.vue?vue&type=script&lang=js"
export * from "./GameStatus.vue?vue&type=script&lang=js"
import style0 from "./GameStatus.vue?vue&type=style&index=0&id=7fceb21a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports